import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NocodeHeader from '@/components/nocode/NocodeHeader';
import HeroSection from '@/components/nocode/HeroSection';
import WakeUpCallSection from '@/components/nocode/WakeUpCallSection';
import FAQSection from '@/components/nocode/FAQSection';
import SEOHead from '@/components/SEO/SEOHead';
import { seoConfig } from '@/config/seoConfig';
import { generateFAQSchema } from '@/utils/schemaUtils';
import { motion } from 'framer-motion';

const NocodeIndex = () => {
  const navigate = useNavigate();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  // FAQs for schema
  const faqs = [
    {
      question: "Do I need technical knowledge to attend this training?",
      answer: "No, our training is designed for all skill levels. No coding or technical background is required."
    },
    {
      question: "What if I miss the live session?",
      answer: "All participants receive lifetime access to the training recordings, so you can watch at your convenience."
    },
    {
      question: "Is there support available after the training?",
      answer: "Yes, all participants get access to our private community where you can ask questions and get ongoing support."
    },
    {
      question: "How is this training different from others?",
      answer: "Our training focuses specifically on leveraging AI for no-code development, with real-time demonstration and practical guidance."
    }
  ];

  // Generate FAQ schema
  const faqSchema = generateFAQSchema(faqs);
  
  // Combine schemas
  const structuredData = [faqSchema];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen w-full bg-white text-gray-800 font-poppins overflow-x-hidden"
    >
      <SEOHead 
        {...seoConfig.nocode}
        structuredData={structuredData}
        canonical="https://lovabuild.com/nocode"
      />
      <NocodeHeader />
      
      <main className="w-full overflow-hidden">
        <HeroSection />
        <WakeUpCallSection />
        <FAQSection />
      </main>
    </motion.div>
  );
};

export default NocodeIndex;
